import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://kshkummqbzhqrorlowxr.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtzaGt1bW1xYnpocXJvcmxvd3hyIiwiaWF0IjoxNzg5NzkwMTI4LCJleHAiOjIxMDUzNjYxMjh9.FCYaAouK8LflRhEL1GbmYbiJCx3UeeSp_fUXZlYg5Fs';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;